<div class="admin-menu-items">
  <header class="page-header">
    <div class="header-content">
      <h1>
        <i class="fas fa-utensils"></i>
        Gestion des Articles
      </h1>
      <p class="subtitle">Gérez les articles de menu de tous les restaurants</p>
    </div>
    <div class="header-actions">
      <button (click)="openCreateModal()" class="btn btn-primary">
        <i class="fas fa-plus"></i>
        Nouvel article
      </button>
    </div>
  </header>

  <!-- Statistiques rapides -->
  <div class="stats-row">
    <div class="stat-item">
      <span class="stat-value">{{ store.totalItems() }}</span>
      <span class="stat-label">Total articles</span>
    </div>
    <div class="stat-item">
      <span class="stat-value">{{ store.activeItems() }}</span>
      <span class="stat-label">Actifs</span>
    </div>
    <div class="stat-item">
      <span class="stat-value">{{ store.outOfStockItems() }}</span>
      <span class="stat-label">Rupture de stock</span>
    </div>
    <div class="stat-item">
      <span class="stat-value">{{
        store.averagePrice() | oskCurrency: 'EUR'
      }}</span>
      <span class="stat-label">Prix moyen</span>
    </div>
  </div>

  <!-- Filtres -->
  <div class="filters-section">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input
        (ngModelChange)="onSearch($event)"
        [(ngModel)]="searchTerm"
        placeholder="Rechercher un article..."
        type="text"
      />
    </div>
    <div class="filter-group">
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="restaurantFilter">
        <option value="">Tous les restaurants</option>
        @for (restaurant of store.restaurants(); track restaurant.id) {
          <option [value]="restaurant.id">{{ restaurant.name }}</option>
        }
      </select>
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="categoryFilter">
        <option value="">Toutes les catégories</option>
        @for (category of filteredCategories(); track category.id) {
          <option [value]="category.id">{{ category.name }}</option>
        }
      </select>
      <select (ngModelChange)="onFilterChange()" [(ngModel)]="statusFilter">
        <option value="">Tous les statuts</option>
        <option value="available">Disponible</option>
        <option value="unavailable">Indisponible</option>
        <option value="outOfStock">Rupture de stock</option>
      </select>
    </div>
    <div class="view-toggle">
      <button
        (click)="setViewMode('grid')"
        [class.active]="viewMode() === 'grid'"
        class="view-btn"
      >
        <i class="fas fa-th-large"></i>
      </button>
      <button
        (click)="setViewMode('list')"
        [class.active]="viewMode() === 'list'"
        class="view-btn"
      >
        <i class="fas fa-list"></i>
      </button>
    </div>
  </div>

  <!-- Liste des articles -->
  <div class="items-container">
    @if (store.loading()) {
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Chargement des articles...</p>
      </div>
    } @else if (filteredItems().length === 0) {
      <div class="empty-state">
        <i class="fas fa-hamburger"></i>
        <h3>Aucun article trouvé</h3>
        <p>Ajoutez votre premier article au menu.</p>
        <button (click)="openCreateModal()" class="btn btn-primary">
          <i class="fas fa-plus"></i>
          Créer un article
        </button>
      </div>
    } @else {
      <!-- Vue Grille -->
      @if (viewMode() === 'grid') {
        <div class="items-grid">
          @for (item of filteredItems(); track item.id) {
            <div
              [class.out-of-stock]="item.outOfStock"
              [class.unavailable]="!item.available"
              class="item-card"
            >
              <div class="item-image">
                @if (item.imageUrl) {
                  <img [alt]="item.name" [src]="item.imageUrl" />
                } @else {
                  <div class="image-placeholder">
                    <i class="fas fa-image"></i>
                  </div>
                }
                @if (item.featured) {
                  <span class="badge featured">
                    <i class="fas fa-star"></i>
                  </span>
                }
                @if (item.outOfStock) {
                  <span class="badge out-of-stock">Rupture</span>
                }
              </div>

              <div class="item-body">
                <div class="item-category">{{ item.categoryName }}</div>
                <h3 class="item-name">{{ item.name }}</h3>
                <p class="item-description">
                  {{ item.description | slice: 0 : 80
                  }}{{ (item.description?.length ?? 0) > 80 ? '...' : '' }}
                </p>

                <div class="item-meta">
                  <span class="item-price">{{
                    item.price | oskCurrency: 'EUR'
                  }}</span>
                  @if (item.discountPrice) {
                    <span class="original-price">{{
                      item.originalPrice | oskCurrency: 'EUR'
                    }}</span>
                  }
                </div>

                @if (item.allergens?.length) {
                  <div class="allergens">
                    @for (
                      allergen of (item.allergens ?? []).slice(0, 3);
                      track allergen
                    ) {
                      <span class="allergen-tag">{{ allergen }}</span>
                    }
                    @if ((item.allergens?.length ?? 0) > 3) {
                      <span class="allergen-more"
                        >+{{ (item.allergens?.length ?? 0) - 3 }}</span
                      >
                    }
                  </div>
                }
              </div>

              <div class="item-footer">
                <div class="item-actions">
                  <button
                    (click)="editItem(item)"
                    class="btn-icon"
                    title="Modifier"
                  >
                    <i class="fas fa-edit"></i>
                  </button>
                  <button
                    (click)="duplicateItem(item)"
                    class="btn-icon"
                    title="Dupliquer"
                  >
                    <i class="fas fa-copy"></i>
                  </button>
                  <button
                    (click)="deleteItem(item)"
                    class="btn-icon danger"
                    title="Supprimer"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                <label class="toggle-mini">
                  <input
                    (change)="toggleAvailability(item)"
                    [checked]="item.available"
                    type="checkbox"
                  />
                  <span class="toggle-slider"></span>
                </label>
              </div>
            </div>
          }
        </div>
      }

      <!-- Vue Liste -->
      @if (viewMode() === 'list') {
        <div class="items-table-container">
          <table class="items-table">
            <thead>
              <tr>
                <th class="th-image">Image</th>
                <th>Nom</th>
                <th>Catégorie</th>
                <th>Restaurant</th>
                <th>Prix</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (item of filteredItems(); track item.id) {
                <tr [class.unavailable]="!item.available">
                  <td class="td-image">
                    @if (item.imageUrl) {
                      <img [alt]="item.name" [src]="item.imageUrl" />
                    } @else {
                      <div class="image-placeholder-mini">
                        <i class="fas fa-image"></i>
                      </div>
                    }
                  </td>
                  <td>
                    <div class="item-name-cell">
                      <strong>{{ item.name }}</strong>
                      @if (item.featured) {
                        <i class="fas fa-star featured-icon"></i>
                      }
                    </div>
                  </td>
                  <td>{{ item.categoryName }}</td>
                  <td>{{ item.restaurantName }}</td>
                  <td class="td-price">
                    <span class="price">{{
                      item.price | oskCurrency: 'EUR'
                    }}</span>
                    @if (item.discountPrice) {
                      <span class="original-price">{{
                        item.originalPrice | oskCurrency: 'EUR'
                      }}</span>
                    }
                  </td>
                  <td>
                    <span [class]="getStatusClass(item)" class="status-badge">
                      {{ getStatusLabel(item) }}
                    </span>
                  </td>
                  <td class="td-actions">
                    <button
                      (click)="editItem(item)"
                      class="btn-icon"
                      title="Modifier"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      (click)="duplicateItem(item)"
                      class="btn-icon"
                      title="Dupliquer"
                    >
                      <i class="fas fa-copy"></i>
                    </button>
                    <button
                      (click)="deleteItem(item)"
                      class="btn-icon danger"
                      title="Supprimer"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>

  <!-- Pagination -->
  @if (store.totalPages() > 1) {
    <div class="pagination">
      <button
        (click)="goToPage(store.currentPage() - 1)"
        [disabled]="store.currentPage() === 0"
        class="btn btn-icon"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <span class="page-info">
        Page {{ store.currentPage() + 1 }} sur {{ store.totalPages() }}
      </span>

      <button
        (click)="goToPage(store.currentPage() + 1)"
        [disabled]="store.currentPage() >= store.totalPages() - 1"
        class="btn btn-icon"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  }

  <!-- Modal création/édition -->
  @if (showModal()) {
    <div (click)="closeModal()" class="modal-overlay">
      <div (click)="$event.stopPropagation()" class="modal modal-large">
        <div class="modal-header">
          <h2>{{ editingItem() ? "Modifier l'article" : 'Nouvel article' }}</h2>
          <button (click)="closeModal()" class="btn-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <form (ngSubmit)="saveItem()" [formGroup]="itemForm">
          <div class="modal-body">
            <div class="form-grid">
              <div class="form-column">
                <div class="form-group">
                  <label for="restaurant">Restaurant *</label>
                  <select
                    (ngModelChange)="onRestaurantChange($event)"
                    formControlName="restaurantId"
                    id="restaurant"
                  >
                    <option value="">Sélectionner un restaurant</option>
                    @for (
                      restaurant of store.restaurants();
                      track restaurant.id
                    ) {
                      <option [value]="restaurant.id">
                        {{ restaurant.name }}
                      </option>
                    }
                  </select>
                </div>

                <div class="form-group">
                  <label for="category">Catégorie *</label>
                  <select formControlName="categoryId" id="category">
                    <option value="">Sélectionner une catégorie</option>
                    @for (category of formCategories(); track category.id) {
                      <option [value]="category.id">{{ category.name }}</option>
                    }
                  </select>
                </div>

                <div class="form-group">
                  <label for="name">Nom de l'article *</label>
                  <input
                    formControlName="name"
                    id="name"
                    placeholder="Ex: Burger Classic"
                    type="text"
                  />
                </div>

                <div class="form-group">
                  <label for="description">Description</label>
                  <textarea
                    formControlName="description"
                    id="description"
                    placeholder="Description de l'article..."
                    rows="3"
                  ></textarea>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label for="price">Prix (€) *</label>
                    <input
                      formControlName="price"
                      id="price"
                      min="0"
                      step="0.01"
                      type="number"
                    />
                  </div>
                  <div class="form-group">
                    <label for="discountPrice">Prix promo (€)</label>
                    <input
                      formControlName="discountPrice"
                      id="discountPrice"
                      min="0"
                      step="0.01"
                      type="number"
                    />
                  </div>
                </div>
              </div>

              <div class="form-column">
                <div class="form-group">
                  <label>Image</label>
                  <div class="image-upload">
                    <div class="image-preview">
                      @if (imagePreview()) {
                        <img [src]="imagePreview()" alt="Aperçu" />
                      } @else {
                        <i class="fas fa-cloud-upload-alt"></i>
                        <span>Glissez une image ou cliquez</span>
                      }
                    </div>
                    <input
                      (change)="onImageChange($event)"
                      accept="image/*"
                      type="file"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label>Allergènes</label>
                  <div class="allergen-checkboxes">
                    @for (allergen of availableAllergens; track allergen) {
                      <label class="allergen-checkbox">
                        <input
                          (change)="toggleAllergen(allergen)"
                          [checked]="selectedAllergens().includes(allergen)"
                          type="checkbox"
                        />
                        <span>{{ allergen }}</span>
                      </label>
                    }
                  </div>
                </div>

                <div class="form-group">
                  <label>Options</label>
                  <div class="options-checkboxes">
                    <label class="option-checkbox">
                      <input formControlName="available" type="checkbox" />
                      <span>Disponible</span>
                    </label>
                    <label class="option-checkbox">
                      <input formControlName="featured" type="checkbox" />
                      <span>Mis en avant</span>
                    </label>
                    <label class="option-checkbox">
                      <input formControlName="vegetarian" type="checkbox" />
                      <span>Végétarien</span>
                    </label>
                    <label class="option-checkbox">
                      <input formControlName="vegan" type="checkbox" />
                      <span>Végan</span>
                    </label>
                    <label class="option-checkbox">
                      <input formControlName="glutenFree" type="checkbox" />
                      <span>Sans gluten</span>
                    </label>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label for="calories">Calories</label>
                    <input
                      formControlName="calories"
                      id="calories"
                      min="0"
                      type="number"
                    />
                  </div>
                  <div class="form-group">
                    <label for="preparationTime">Temps prép. (min)</label>
                    <input
                      formControlName="preparationTime"
                      id="preparationTime"
                      min="0"
                      type="number"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              (click)="closeModal()"
              class="btn btn-secondary"
              type="button"
            >
              Annuler
            </button>
            <button
              [disabled]="itemForm.invalid || store.saving()"
              class="btn btn-primary"
              type="submit"
            >
              @if (store.saving()) {
                <span class="spinner-sm"></span>
              }
              {{ editingItem() ? 'Modifier' : 'Créer' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }
</div>
